import './budget.css';

import FilterResume from '../../filterResume/filterResume';

/*** NOTE AU SUJET DE LA FACETTE BUDGET **************************************************************/
/* Le métier désirant que le minimum affiché corresponde au palier le plus bas des prix remontés     */
/* et comme il n'est pas possible pour l'utilisateur de modifier lui-même le minimum,                */
/* on est obligé de mettre en place un système de type max price, avec un minimum envoyé toujours    */
/* équivalent à 0, car sinon, le minimum varierait au fur et à mesure des retours des requêtes, sans */
/* pouvoir jamais être redescendu (un min à un moment donné excluant de pouvoir revenir en dessous)  */
/*****************************************************************************************************/
export const BudgetView = Backbone.View.extend({
  /**
   * Initialize budget view
   * @param {Object} options
   */
  initialize: function (options) {
    this.filtersModel = options.filtersModel;
    this.rangeSlider = {};
    this.rangeSelector = '.js-Search-priceRange';
    this.initListener();
  },

  initListener: function () {
    this.stopListening(dispatcher, 'facettes:budget:initRangeSelector');
    this.listenTo(dispatcher, 'facettes:budget:initRangeSelector', this.initRangeSelector);

    this.stopListening(dispatcher, 'facettes:budget:render');
    this.listenTo(dispatcher, 'facettes:budget:render', this.render);

    this.stopListening(dispatcher, 'facettes:budget:reset');
    this.listenTo(dispatcher, 'facettes:budget:reset', this.resetRangeSlider);
  },

  /**
   * Handling price slider
   * @param {Object} facette
   * @param {{min: number, max: number}} facette.values
   * @param {{min: number, max: number}} facette.selected
   * @param {boolean} isOpenMax - to have result with price > 3000
   * @rules - max value had to be > min value (no equality allowed)
   *        - max value displayed can't be > 3000
   *        - always use open max, to have result with price > 3000
   */
  initRangeSelector: function (facette, isOpenMax = false) {
    const selector = this.rangeSelector;
    const {values, selected} = facette;
    const currencyCode = GLOBAL_SCRIPTS.CURRENCY_CODE;
    const currencyBefore = GLOBAL_SCRIPTS.CURRENCY_BEFORE;
    const currencyAfter = GLOBAL_SCRIPTS.CURRENCY_AFTER;

    const minSelectable = 50;
    const maxSelectable = 3000;
    const baseMinValue = values.min > minSelectable ? values.min : minSelectable;
    const baseMaxValue = values.max < maxSelectable ? values.max : maxSelectable;
    const userMinValue = selected.min < baseMinValue ? baseMinValue : selected.min;
    const userMaxValue = selected.max > baseMaxValue ? baseMaxValue : selected.max;

    let datas = {
      selector: selector,
      tooltips: false,
      hasMinVariable: true,
      padding: [baseMinValue - minSelectable, Math.max(0, maxSelectable - baseMaxValue)],
      range: {
        min: minSelectable,
        max: maxSelectable
      },
      start: {
        min: userMinValue,
        max: userMaxValue
      },
      isOpenMax
    };

    if ($(selector).length) {
      this.rangeSlider = Form.range.init(datas,
        (values) => { // onChange event (release handle)
          let minValue;
          let maxValue;

          // If the currency sign is before the value, get index 1 otherwise index 0 by default.
          if (datas.hasMinVariable) {
            minValue = this.getRawPrice(values[0], baseMinValue);
            maxValue = this.getRawPrice(values[1], baseMaxValue);
          } else {
            minValue = baseMinValue;
            maxValue = this.getRawPrice(values[0], baseMaxValue);
          }

          // preventing value equality
          if (maxValue <= minValue) {
            if (minValue >= baseMaxValue) {
              minValue = maxValue - 50;
            } else {
              maxValue = minValue + 50;
              if (datas.hasMinVariable) {
                this.rangeSlider.set([minValue, maxValue]);
              } else {
                this.rangeSlider.set(maxValue);
              }
            }
          }

          // update Budget item
          const $facetteBudget = $('#js_facette_budget');
          const $budgetOpener = $('#price_opener');
          const initialBudgetValues = baseMinValue + '_' + baseMaxValue + '_' + currencyCode;
          let budgetValue = minValue + '_' + maxValue + '_' + currencyCode;

          // if budget facet is reset to initial values, set option to '' (empty)
          if (budgetValue === initialBudgetValues) {
            budgetValue = '';
            SEARCH_SCRIPTS.IS_FACETTE_BUDGET_SELECTED = false;
            $budgetOpener.removeClass('active');
          } else {
            SEARCH_SCRIPTS.IS_FACETTE_BUDGET_SELECTED = true;
            $budgetOpener.addClass('active');
          }

          const plusSign = maxValue >= maxSelectable && isOpenMax ? '<span class="plus">+</span>' : '';

          // Update fixed tooltips label
          this.updateTooltips({
            min: currencyBefore + minValue + currencyAfter,
            max: currencyBefore + maxValue + currencyAfter + plusSign
          });

          if (!DEVICE.isMobile) {
            // Update opener button state
            dispatcher.trigger('search:filters:checkActive');
          }

          if (budgetValue !== $facetteBudget.val()) {
            // Update html field value
            $facetteBudget.val(budgetValue);

            const selectionOrder = this.filtersModel.get('selectionOrder').filter(item => typeof item !== 'object');

            if (SEARCH_SCRIPTS.IS_FACETTE_BUDGET_SELECTED) {
              selectionOrder.unshift({'PRICE': budgetValue});
            }

            // Update filtersModel with new values
            this.filtersModel.set({'PRICE': budgetValue, 'selectionOrder': selectionOrder});

            FilterResume.update();
          }
        },
        (values) => { // onUpdate event (onSlide)
          let minValue, maxValue;

          // If the currency sign is before the value, get index 1 otherwise index 0 by default.
          if (datas.hasMinVariable) {
            minValue = this.getRawPrice(values[0], baseMinValue);
            maxValue = this.getRawPrice(values[1], baseMaxValue);
          } else {
            maxValue = this.getRawPrice(values[0], baseMaxValue);
          }

          if (maxValue <= (minValue + 50)) {
            return false;
          }

          const plusSign = maxValue >= maxSelectable && isOpenMax ? '<span class="plus">+</span>' : '';

          // Update tooltips label
          this.updateTooltips({
            min: currencyBefore + minValue + currencyAfter,
            max: currencyBefore + maxValue + currencyAfter + plusSign
          });
        }
      );
    }
  },

  /**
   * Get Price without sign
   * @param {array} values
   * @param {string|number} valueIfNull
   * @return {number}
   */
  getRawPrice: function (values, valueIfNull = null) {
    return parseInt(values || valueIfNull);
  },

  /**
   * Update external tooltips
   * @param selector
   * @param min
   * @param max
   */
  updateTooltips: function ({min, max}) {
    // update tooltips label
    $('#form-rangeMin').html(min);
    $('#form-rangeMax').html(max);
  },

  resetRangeSlider: function () {
    const options = this.rangeSlider.options;
    if (options) {
      this.rangeSlider.set([options.range.min, options.range.max]);
    }
    this.filtersModel.set({'PRICE': '', 'lastModifiedFilter': 'PRICE'});
    FilterResume.update();

    $('#price_opener').removeClass('active');
  }
});